import { useCallback, useEffect, useRef, useState } from "react";
import { IComboBox, IComboBoxOption } from "@fluentui/react";
import { Ifilter } from "../../interfaces/IFilter";
import PersonaService from "../../services/PersonaService";
import { IItemComboBaseDTO } from "../../interfaces/base/IBase";
import GuardiaService from "../../services/guardiaService";

const UseComboGuardiaProgramacionHorarios = (isOpen: boolean) => {
    const controllerRef = useRef<AbortController>(new AbortController());
    const [filter, setFilter] = useState<Ifilter>({
        skip: 0,
        take: 20,
        search: ""
    });

    const [dataComboGuardiaProgramacion, setDataComboGuardiaProgramacion] = useState<IItemComboBaseDTO[]>([]);
    const comboBoxRefGuardiaProgramacion = useRef<IComboBox>(null);

    const onClickComboGuardiaProgramacion = () => comboBoxRefGuardiaProgramacion.current?.focus(true);

    const _openOption = useCallback(
        () => comboBoxRefGuardiaProgramacion.current?.focus(true),
        []
    );

    const _onkeyUpSearchGuardiaProgramacion = (event: React.KeyboardEvent<IComboBox>) => {
        if (event.code === "Escape") {
            comboBoxRefGuardiaProgramacion.current?.focus(false);
            setFilter({
                skip: 0,
                take: 20,
                search: ""
            });
        } else {
            _openOption();
            let { value } = event?.target as HTMLInputElement;
            setFilter({ ...filter, search: value });
        }
    };

    const listarCombo = () => {
        controllerRef.current.abort();
        const newController = new AbortController();
        controllerRef.current = newController;
        GuardiaService.comboGuardiasProgramacion(filter, newController).then((res) => {
            if (res.status === 200) {
                const data = [
                    { key: '0', text: '--Seleccionar--' },
                    ...res.data
                ];
                setDataComboGuardiaProgramacion(data);
            }
        });
    };

    useEffect(() => {
        if (isOpen) {
            listarCombo();
        }
    }, [isOpen, filter]);

    return {
        dataComboGuardiaProgramacion,
        onClickComboGuardiaProgramacion,
        _onkeyUpSearchGuardiaProgramacion,
        comboBoxRefGuardiaProgramacion,
        filter,
        setFilter
    };
}

export { UseComboGuardiaProgramacionHorarios }
